var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      !_vm.isMobile
        ? _c(
            "el-dialog",
            {
              staticClass: "login_box",
              attrs: { visible: _vm.adminDia, "append-to-body": true },
              on: {
                "update:visible": function ($event) {
                  _vm.adminDia = $event
                },
              },
            },
            [
              _c("div", { staticClass: "login_box_title" }, [
                _vm._v("\n       请选择登录方式\n      "),
              ]),
              _vm._v(" "),
              _c(
                "el-carousel",
                {
                  ref: "carousel",
                  attrs: {
                    trigger: "click",
                    arrow: "never",
                    "indicator-position": "none",
                    autoplay: false,
                  },
                },
                [
                  _c("el-carousel-item", [
                    _c(
                      "div",
                      { staticClass: "login_box_list" },
                      _vm._l(_vm.bntsList, function (item) {
                        return _c(
                          "div",
                          {
                            key: item.id,
                            staticClass: "login_box_li",
                            on: {
                              click: function ($event) {
                                return _vm.tologin(item)
                              },
                            },
                          },
                          [
                            _c("img", {
                              staticClass: "login_box_icon",
                              attrs: {
                                src: require("@/assets/newimg/login/icon_l_" +
                                  (item.id == "4" ? "1" : item.id) +
                                  ".png"),
                                alt: "",
                              },
                            }),
                            _vm._v(" "),
                            _c("span", [_vm._v(_vm._s(item.name))]),
                            _vm._v(" "),
                            _c("img", {
                              staticClass: "login_box_r",
                              attrs: {
                                src: require("@/assets/newimg/login/icon_r.png"),
                                alt: "",
                              },
                            }),
                          ]
                        )
                      }),
                      0
                    ),
                  ]),
                  _vm._v(" "),
                  _c("el-carousel-item", [
                    _c(
                      "div",
                      { staticClass: "login_box_list" },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "register black",
                            on: { click: _vm.tologin },
                          },
                          [_vm._v("返回")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form",
                          {
                            ref: "userMsg",
                            attrs: { model: _vm.userMsg, rules: _vm.userRules },
                          },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { prop: "username" } },
                              [
                                _c("el-input", {
                                  attrs: {
                                    "prefix-icon": "el-icon-user",
                                    placeholder: "请输入账号",
                                  },
                                  model: {
                                    value: _vm.userMsg.username,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.userMsg, "username", $$v)
                                    },
                                    expression: "userMsg.username",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              { attrs: { prop: "password" } },
                              [
                                _c("el-input", {
                                  attrs: {
                                    "prefix-icon": "el-icon-lock",
                                    type: "password",
                                    placeholder: "请输入密码",
                                  },
                                  model: {
                                    value: _vm.userMsg.password,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.userMsg, "password", $$v)
                                    },
                                    expression: "userMsg.password",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        0
                          ? _c(
                              "div",
                              { staticClass: "footerModles" },
                              [
                                _c(
                                  "el-checkbox",
                                  {
                                    model: {
                                      value: _vm.checked,
                                      callback: function ($$v) {
                                        _vm.checked = $$v
                                      },
                                      expression: "checked",
                                    },
                                  },
                                  [_vm._v("记住密码")]
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "register" }, [
                                  _c("a", { attrs: { href: "##" } }, [
                                    _vm._v("忘记密码"),
                                  ]),
                                ]),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.isEnter === true
                          ? _c(
                              "el-button",
                              {
                                staticClass: "homeLoginBtn",
                                attrs: {
                                  loading: _vm.loading,
                                  type: "primary",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.login("userMsg")
                                  },
                                },
                              },
                              [_vm._v("登录\n                  ")]
                            )
                          : _c(
                              "el-button",
                              {
                                staticClass: "homeLoginBtn",
                                attrs: { type: "primary" },
                                on: { click: _vm.login },
                              },
                              [_vm._v("注册\n                  ")]
                            ),
                        _vm._v(" "),
                        0
                          ? _c(
                              "span",
                              {
                                staticClass: "register",
                                on: {
                                  click: function ($event) {
                                    _vm.isEnter = false
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n                      没有账号? 立即注册\n                  "
                                ),
                              ]
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _vm.isLocalBjcaTestEnabled
                    ? _c("el-carousel-item", [
                        _c(
                          "div",
                          { staticClass: "login_box_list" },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "register black",
                                on: { click: _vm.backToLoginOptions },
                              },
                              [_vm._v("返回")]
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form",
                              {
                                ref: "localTestForm",
                                attrs: {
                                  model: _vm.localTestForm,
                                  rules: _vm.localTestRules,
                                },
                              },
                              [
                                _c(
                                  "el-form-item",
                                  { attrs: { prop: "jyId" } },
                                  [
                                    _c("el-input", {
                                      attrs: {
                                        "prefix-icon": "el-icon-user",
                                        placeholder: "请输入教育ID",
                                        clearable: "",
                                      },
                                      nativeOn: {
                                        keyup: function ($event) {
                                          if (
                                            !$event.type.indexOf("key") &&
                                            _vm._k(
                                              $event.keyCode,
                                              "enter",
                                              13,
                                              $event.key,
                                              "Enter"
                                            )
                                          ) {
                                            return null
                                          }
                                          return _vm.localTestLogin($event)
                                        },
                                      },
                                      model: {
                                        value: _vm.localTestForm.jyId,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.localTestForm,
                                            "jyId",
                                            $$v
                                          )
                                        },
                                        expression: "localTestForm.jyId",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-button",
                              {
                                staticClass: "homeLoginBtn",
                                attrs: {
                                  loading: _vm.localTestLoading,
                                  type: "primary",
                                },
                                on: { click: _vm.localTestLogin },
                              },
                              [
                                _vm._v(
                                  "\n                      本地测试登录\n                  "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ])
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "login_box_foot" }, [
                _c("div", [
                  _vm._v("咨询电话（北京市教育统一认证）:"),
                  _c("span", [_vm._v("4008315209, 4008310001")]),
                ]),
                _vm._v(" "),
                _c("div", [
                  _vm._v("咨询时间:"),
                  _c("span", [_vm._v("9:00-17:00")]),
                ]),
              ]),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isMobile
        ? _c("MobileLogin", {
            attrs: { visible: _vm.adminDia },
            on: {
              "update:visible": function ($event) {
                _vm.adminDia = $event
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }